const dateObj = new Date();
const yearMonth = dateObj.getUTCFullYear() + '-' + (dateObj.getUTCMonth() + 1);

export const CALENDAR_DATA = [
    {
        title: 'All Day Event',
        start: yearMonth + '-01',
        className: 'red'
    },
    {
        title: 'Long Event',
        start: yearMonth + '-07',
        end: yearMonth + '-10'
    },
    {
        id: 999,
        title: 'Repeating Event',
        start: yearMonth + '-09T16:00:00'
    },
    {
        id: 999,
        title: 'Repeating Event',
        start: yearMonth + '-16T16:00:00'
    },
    {
        title: 'Conference',
        start: yearMonth + '-11',
        end: yearMonth + '-13'
    },
    {
        title: 'Meeting',
        startAt: yearMonth + '-12T10:30:00',
        endAt: yearMonth + '-12T12:30:00'
    },
    {
        title: 'Lunch',
        start: yearMonth + '-12T12:00:00'
    },
    {
        title: 'Meeting',
        start: yearMonth + '-12T14:30:00'
    },
    {
        title: 'Happy Hour',
        start: yearMonth + '-12T17:30:00'
    },
    {
        title: 'Dinner',
        start: yearMonth + '-12T20:00:00'
    },
    {
        title: 'Birthday Party',
        start: yearMonth + '-13T07:00:00'
    },
    {
        title: 'Click for Google',
        url: 'http://google.com/',
        startAt: yearMonth + '-28',
        className: 'bg-red',
    }
];

export const CALENDAR_OPTIONS = {
    themeSystem: 'standard',
    defaultView: 'month',
    nowIndicator: true,
    editable: true,
    eventLimit: false,
    navLinks: true,
    navLinkDayClick: () => {},
    navLinkWeekClick: () => {},
    businessHours: [
        {
            dow: [ 1, 2, 3 ],
            start: '08:00',
            end: '18:00',
        },
        {
            dow: [ 4, 5 ],
            start: '10:00',
            end: '16:00',
        }
    ],
    weekNumbers: true,
    header: {
        left: 'title today,prev,next',
        center: '',
        right: 'month,agendaWeek,agendaDay'
    },
    selectable: true,
    locale: 'es',
    events: [],
    buttonText: {
        today: 'today',
        prev: 'edu',
        next: 'roberto',
        month: 'me comen el nabo',
        agendaWeek: 'son subnormales',
        agendaDay: 'esto es para junior',
        listMonth: 'y para monguer'
    },
    buttonIcons: {
        prev: 'left-single-arrow',
        next: 'right-single-arrow',
        prevYear: 'left-double-arrow',
        nextYear: 'right-double-arrow'
    }

};

